import React, {useEffect, useState} from 'react';
import {AudienceSegment} from "types/AudienceSegment";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    audienceSegment: AudienceSegment | null
    show: boolean
    onDelete?: (audienceSegment: AudienceSegment) => any
    onDeleteFail?: (audienceSegment: AudienceSegment, error: unknown) => any
    onCancel?: () => any
}

function DeleteAudienceSegment(props: Props) {
    const {audienceSegment, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(audienceSegment?.name || 'this audience segment');
    const {mutateAsync: deleteAudienceSegment} = useMutation(ngage.audienceSegments.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(audienceSegment) setName(audienceSegment.name)
    }, [audienceSegment]);

    async function handleDeleteAudienceSegment() {
        if (audienceSegment) {
            try {
                await deleteAudienceSegment(audienceSegment.id)
                await invalidate('audience-segments.all')

                notify("success", "AudienceSegment Deleted", `${audienceSegment.name} has been permanently removed`)

                if (onDelete) onDelete(audienceSegment)
            } catch (error) {
                notify("error", "AudienceSegment Not Deleted", `${audienceSegment.name} could not be removed`)

                if (onDeleteFail) onDeleteFail(audienceSegment, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Audience Segment"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteAudienceSegment}
            onCancel={handleCancel}
        />
    );
}

export default DeleteAudienceSegment;